module.exports = __webpack_public_path__ + "static/img/stored-value-card-repair.43fb94c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/stored-value-card-repair.png
// module id = JAei
// module chunks = 1